import { z } from "zod";

export const suspensionRequestSchema = z.object({
  reason: z
    .string()
    .min(1, "La razón para la suspensión es obligatoria")
    .max(120, "La razón para la suspensión no puede exceder los 120 caracteres")
    .nonempty()
    .refine((val) => {
      return val.trim().length > 0;
    }, "La descripción del rol no puede estar vacía"),
  document: z
    .instanceof(File)
    .refine((file) => file.size <= 10 * 1024 * 1024, {
      error: "El archivo debe ser menor a 10MB",
    })
    .refine(
      (file) => {
        const allowedTypes = ["application/pdf", "image/jpeg", "image/png"];
        return allowedTypes.includes(file.type);
      },
      {
        error: "Solo se permiten archivos PDF, JPG o PNG",
      },
    )
    .nullable()
    .optional(),
});

export type SuspensionRequestFormData = z.infer<typeof suspensionRequestSchema>;
